// File: Services/ClientItemsService.js
import config from '../config';
import selectedEnvironment from '../env';

const baseURL = config[selectedEnvironment].API_URL;
const ClientItems_API_URL = `${baseURL}/ClientItems`;

const GetClientItemsByCaseId = async (caseId, auth) => {
    const response = await fetch(`${ClientItems_API_URL}/ByCaseId/${caseId}`, {
        method: 'GET',
        headers: {
            Authorization: 'Bearer ' + auth,
            'Content-Type': 'application/json',
        },
    });
    return response;
};

const AddClientItems = async (items, auth) => {
    const response = await fetch(`${ClientItems_API_URL}/Create`, {
        method: 'POST',
        headers: {
            "Authorization": 'Bearer ' + auth,
            "Content-Type": "application/json"
        },
        body: JSON.stringify({ Items: items })
    });

    return response;
};

const UploadClientItemImage = async (file, caseId, makat, auth) => {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('caseId', caseId);
    formData.append('makat', makat);

    const response = await fetch(`${ClientItems_API_URL}/UploadImage`, {
        method: 'POST',
        headers: {
            "Authorization": 'Bearer ' + auth,
        },
        body: formData
    });

    return response;
};

const UpdateClientItem = async (
    caseId,
    originalMakat,
    newMakat,
    newName,
    newPrice,
    includeVat,
    imageUrl,
    auth,
    clearImage = false,
    prices = null
) => {
    const body = {
        CaseId: caseId,
        Makat: newMakat,
        Name: newName,
        Price: newPrice,
        IncludeVat: includeVat,
        ImageUrl: imageUrl,
        OriginalMakat: originalMakat,
        ClearImage: clearImage,
    };
    if (prices != null) {
        body.Prices = prices;
    }

    const response = await fetch(`${ClientItems_API_URL}/Update`, {
        method: 'PUT',
        headers: {
            Authorization: 'Bearer ' + auth,
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(body),
    });
    return response;
};

const DeleteClientItem = async (makat, caseId, auth) => {
    const response = await fetch(`${ClientItems_API_URL}/Delete/${makat}/${caseId}`, {
        method: 'DELETE',
        headers: {
            Authorization: 'Bearer ' + auth,
            'Content-Type': 'application/json',
        },
    });
    return response;
};

const DeleteClientItemImage = async (caseId, id, auth) => {
    const response = await fetch(`${ClientItems_API_URL}/image/${caseId}/${id}`, {
        method: 'DELETE',
        headers: {
            Authorization: 'Bearer ' + auth,
            'Content-Type': 'application/json',
        },
    });
    return response;
};

const GetDefaultClientItem = async (caseId, auth) => {
    const response = await fetch(`${ClientItems_API_URL}/DefaultItem/${caseId}`, {
        method: 'GET',
        headers: {
            Authorization: 'Bearer ' + auth,
            'Content-Type': 'application/json',
        },
    });
    return response;
};

const SetDefaultClientItem = async (caseId, makat, auth) => {
    const response = await fetch(`${ClientItems_API_URL}/SetDefaultItem`, {
        method: 'POST',
        headers: {
            Authorization: 'Bearer ' + auth,
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({ CaseId: caseId, Makat: makat }),
    });
    return response;
};

const ClientItemsService = {
    GetClientItemsByCaseId,
    AddClientItems,
    UpdateClientItem,
    DeleteClientItem,
    DeleteClientItemImage,
    UploadClientItemImage,
    GetDefaultClientItem,
    SetDefaultClientItem,
};

export default ClientItemsService;
